import { angularAMD } from "@pebblepad/amd";
import { isPlainTextOnlySupported } from "../../isPlainTextOnlySupported/isPlainTextOnlySupported";
import { textEditableDirectiveFactory } from "./TextEditableDirectiveFactory";

const setContentEditableAttribute = (attrs, element) => {
    if (attrs.plainTextEditable === "false") {
        element.setAttribute("contenteditable", "false");
        return;
    }

    if (isPlainTextOnlySupported) {
        element.setAttribute("contenteditable", "plaintext-only");
    } else {
        element.setAttribute("contenteditable", "true");
    }
};

angularAMD.directive("plainTextEditable", textEditableDirectiveFactory("plainTextEditable", setContentEditableAttribute));
